import React from "react";
import { Footer, Header, Notification } from "../Components";
import s from "./Public.module.css";

const Public = ({ children }) => (
  <div className="d-flex flex-column">
    <Notification />
    <Header />
    <div className={s.children_container}>{children}</div>
    <Footer />
  </div>
);

export default Public;
